import React from "react";
import MainPage from "./MainPage"
import './Home.css'

export default function Home (){

    return(
        <div className="root">
            <div className="container">
                <MainPage/>
            </div>
        </div>
    )

}